import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BoutiqueView from '@/views/BoutiqueView.vue'
import ComparatifView from '@/views/ComparatifView.vue'
import ContactView from '@/views/ContactView.vue'
import PanierView from '@/views/PanierView.vue'
import DetailsView from '@/views/DetailsView.vue'
import OffresView from '@/views/OffresView.vue'
import TunnelProduit from '@/views/TunnelProduit.vue'
import ConnexionView from '@/views/ConnexionView.vue'
import InscriptionView from '@/views/InscriptionView.vue'
import MotDePasseOublieView from '@/views/MotDePasseOublieView.vue'
import EspaceClientView from '@/views/EspaceClientView.vue'
import PaiementView from '@/views/PaiementView.vue'
import { useAuthClientStore } from '@/store/useAuthClientStore'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      description: "Découvrez Pomme City, votre boutique en ligne dédiée à la vente d'iPhones, Android et accessoires de qualité. Profitez des dernières offres et d'une expérience d'achat fluide.",
      keywords: "Pomme City, vente iPhone, vente Android, accessoires téléphones, boutique en ligne, smartphones",
      title: "Pomme City - Accueil",
      scrollToTop: true
    }    
  },
  {
    path: '/boutique',
    name: 'boutique',
    component: BoutiqueView,
    meta: {
      description: "Explorez notre large sélection de smartphones iPhone, Android et accessoires de téléphone sur Pomme City. Trouvez le produit parfait pour vous.",
      keywords: "Pomme City, iPhone, Android, accessoires téléphones, achat en ligne, smartphones",
      title: "Pomme City - Boutique",
      scrollToTop: true
    }    
  },
  {
    path: '/comparatif',
    name: 'comparatif',
    component: ComparatifView,
    meta: {
      description: "Comparez les iPhones, Android et accessoires disponibles sur Pomme City. Trouvez le meilleur produit qui correspond à vos besoins.",
      keywords: "Pomme City comparatif, iPhone, Android, accessoires, comparaison smartphones",
      title: "Pomme City - Comparatif",
      scrollToTop: true
    }    
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: {
      description: "Contactez Pomme City pour toute question ou assistance concernant nos produits. Nous sommes là pour vous aider à trouver le smartphone ou l'accessoire parfait.",
      keywords: "Pomme City contact, service client, assistance, support, iPhone, Android, accessoires",
      title: "Pomme City - Contact",
      scrollToTop: true
    }    
  },
  {
    path: '/panier',
    name: 'panier',
    component: PanierView,
    meta: {
      description: "Revoyez et finalisez vos achats sur Pomme City. Votre panier contient les meilleurs iPhones, Android et accessoires à prix compétitifs.",
      keywords: "Pomme City panier, achats en ligne, iPhone, Android, accessoires, récapitulatif",
      title: "Pomme City - Panier",
      scrollToTop: true
    }    
  },
  {
    path: '/boutique/produits/tunnel/:id',
    name: 'tunnel-produit',
    component: TunnelProduit,
    meta: {
      description: "Explorez notre large sélection de smartphones iPhone, Android et accessoires de téléphone sur Pomme City. Trouvez le produit parfait pour vous.",
      keywords: "Pomme City, iPhone, Android, accessoires téléphones, achat en ligne, smartphones",
      title: "Pomme City - Produit Détails",
      scrollToTop: true
    }
  },
  {
    path: '/boutique/produits/:id',
    name: 'details',
    component: DetailsView,
    meta: {
      description: "Explorez notre large sélection de smartphones iPhone, Android et accessoires de téléphone sur Pomme City. Trouvez le produit parfait pour vous.",
      keywords: "Pomme City, iPhone, Android, accessoires téléphones, achat en ligne, smartphones",
      title: "Pomme City - Boutique",
      scrollToTop: true
    }
  },
  {
    path: '/bon-plan',
    name: 'offre',
    component: OffresView,
    meta: {
      description: "Ne manquez pas les bons plans de Pomme City ! Découvrez nos offres exclusives sur les iPhones, Android et accessoires de téléphones.",
      keywords: "Pomme City bons plans, réductions, offres spéciales, iPhone, Android, accessoires",
      title: "Pomme City - Bon Plan",
      scrollToTop: true
    }
  },
  {
    path: '/connexion',
    name: 'connexion',
    component: ConnexionView,
    meta: { title: "Pomme City - Connexion", scrollToTop: true }
  },
  {
    path: '/inscription',
    name: 'inscription',
    component: InscriptionView,
    meta: { title: "Pomme City - Inscription", scrollToTop: true }
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'mot-de-passe-oublie',
    component: MotDePasseOublieView,
    meta: { title: "Pomme City - Mot de passe oublié", scrollToTop: true }
  },
  {
    path: '/mon-espace',
    name: 'mon-espace',
    component: EspaceClientView,
    meta: { title: "Pomme City - Mon espace", scrollToTop: true, requiresClient: true }
  },
  {
    path: '/mon-espace/paiement/:id',
    name: 'paiement',
    component: PaiementView,
    meta: { title: "Pomme City - Paiement", scrollToTop: true, requiresClient: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to: any, from: any, savedPosition: any) {
    if (to.meta.scrollToTop) {
      return { top: 0 };
    }
  },
})

router.beforeEach((to: any, from: any, next) => {
  document.title = to.meta.title || "Pomme City";
  
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta && to.meta.description) {
    descriptionMeta.setAttribute('content', to.meta.description);
  }

  const keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (keywordsMeta && to.meta.keywords) {
    keywordsMeta.setAttribute('content', to.meta.keywords);
  }

  // Protection de l'espace client
  if (to.meta.requiresClient) {
    const authClientStore = useAuthClientStore();
    if (!authClientStore.token) {
      return next({ name: 'connexion', query: { redirect: to.fullPath } });
    }
  }

  next();
});

export default router
